import { createApp } from 'vue'
import app from './app.js';

/**
 * Import styles for the entire project here
 */
import appStyles from './css/app.scss'
// import demoStyles from './css/demoSass.scss'

// import envJson from './config/env.json' assert { type: 'json' }

// Vuetify (https://vuetifyjs.com/en/getting-started/installation/)
// npm install vuetify
/*
 * TO USE VUETIFY:
 * - Uncomment the Vuetify items below
 * - Swap the "createApp" lines to the one with ".use(vuetify)"
 * - Put the following <link> in the local HTML templates for icons (including initial Vuetify icons)
 * - <link href="https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css" rel="stylesheet">
 * - Add the following import to the <style> tag of the embed HTML template for icons to work in prod
 * - @import url("https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css");
 */

/* import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
  components,
  directives,
}) */

// PrimeVue (https://primevue.org/installation/)
// npm install primevue
// npm install primeflex --save

/* import PrimeVue from 'primevue/config'
import "primevue/resources/themes/lara-light-indigo/theme.css"; 
import 'primeflex/primeflex.css' */


createApp(app).mount('#process.env.appTargetID'); // NORMAL
// createApp(app).use(PrimeVue).mount('#process.env.appTargetID'); // FOR PRIMEVUE
// createApp(app).use(vuetify).mount('#process.env.appTargetID'); // FOR VUETIFY